export const chainColorMap: Record<string, string> = {
  'eip155:56': '#D69E2E', // Binance Smart Chain - Yellow-600
  'eip155:100': '#319795', // Gnosis Chain - Teal-600
  'eip155:137': '#6B46C1', // Polygon - Purple-700
  'bip122:000000000019d6689c085ae165831e93': '#D69E2E', // Bitcoin - Yellow-600
  'solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ': '#ED8936', // Solana - Orange-500
  'eip155:8453': '#A0AEC0', // Base Mainnet - Gray-400
  'eip155:42161': '#48BB78', // Arbitrum One - Green-500
  'eip155:1284': '#5A67D8', // Moonbeam - Indigo-500
  'eip155:59144': '#718096', // Linea - Gray-500
  'eip155:10': '#90CDF4', // Optimism - Blue-300
  'eip155:250': '#2F855A', // Fantom Opera - Green-700
  'eip155:1285': '#434190', // Moonriver - Indigo-600
  'eip155:43114': '#C53030', // Avalanche C-Chain - Red-600
  'eip155:25': '#68D391', // Cronos Mainnet - Green-400
  'eip155:199': '#F56565', // BitTorrent Chain Mainnet - Red-500
  'eip155:1101': '#9F7AEA', // Polygon zkEVM - Purple-500
  'eip155:1111': '#4A5568', // WEMIX3.0 Mainnet - Gray-600
  'eip155:534352': '#2D3748', // Scroll - Gray-700
  'eip155:42220': '#38A169', // Celo - Green-600
  'eip155:1': '#4299E1', // Ethereum Mainnet - Blue-500
}

export const statusColorMap: Record<string, string> = {
  Registered: '#48BB78', // Green-500
  RegistrationRequested: '#ED8936', // Orange-500
  ClearingRequested: '#D69E2E', // Yellow-500
  Absent: '#718096', // Gray-500
}
